import React from 'react';
import Button from 'components/_UI/Button';
import Text from 'components/_UI/Text';
import { Column } from 'styled/alignment/Column';
import colors from 'theme/colors';
import sizes from 'theme/sizes';
import paths from 'routes/paths';

function RegisterStepFour() {
    return (
        <>
            <Column verticalCenter>
                <Text color={colors.neutral} type='bold' name='highlight'>Para finalizar,</Text>
                <Text color={colors.neutral} type='bold' name='highlight'>Verifique seu e-mail e confirme o</Text>
                <Text color={colors.neutral} type='bold' name='highlight'>seu cadastro</Text>
            </Column>

            <Column 
                paddingRight='13%' 
                paddingLeft='13%'
            >
                <Button               
                    path={paths.login}
                    category='roundedBorded'
                    variant='secondary'
                    size='large'
                    marginTop={sizes.normal}
                >
                    Confirmei meu cadastro
                </Button>

            </Column>
        </>
    )
};

export default RegisterStepFour;